/**
 * Мост MAX Messenger. Библиотека max-web-app.js подключается в index.html
 * и создаёт window.WebApp только внутри клиента MAX.
 *
 * В Telegram и обычном браузере window.WebApp либо отсутствует, либо не имеет
 * пользовательских данных — тогда все вызовы становятся безопасными no-op.
 */

interface MaxBackButton {
  show(): void;
  hide(): void;
  onClick(handler: () => void): void;
  offClick?(handler: () => void): void;
}

interface MaxWebApp {
  initData?: string;
  initDataUnsafe?: {
    user?: {
      id?: number;
      first_name?: string;
      last_name?: string;
      username?: string;
      photo_url?: string;
    };
  };
  ready?(): void;
  close?(): void;
  openLink?(url: string): void;
  BackButton?: MaxBackButton;
}

declare global {
  interface Window {
    WebApp?: MaxWebApp;
  }
}

export function getMaxWebApp(): MaxWebApp | null {
  const app = window.WebApp;
  if (!app) return null;
  // В обычном браузере библиотека тоже определяется, но без initData:
  // не считаем это запуском внутри MAX.
  return app.initData || app.initDataUnsafe?.user ? app : null;
}

export function isMaxHost(): boolean {
  return Boolean(getMaxWebApp());
}

export function maxReady(): void {
  getMaxWebApp()?.ready?.();
}

export function maxOpenLink(url: string): void {
  const app = getMaxWebApp();
  if (app?.openLink) {
    app.openLink(url);
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}

export function maxBackButton(visible: boolean, handler: () => void): () => void {
  const back = getMaxWebApp()?.BackButton;
  if (!back) return () => undefined;

  if (visible) {
    back.show();
    back.onClick(handler);
  } else {
    back.hide();
  }

  return () => {
    back.offClick?.(handler);
  };
}
